import VueRouter from "vue-router";

import AuthLayout from '@/layouts/AuthLayout.vue'
import AuthLayoutPages from '@/layouts/AuthLayoutPages/index.js'

import DashboardLayout from '@/layouts/DashboardLayout.vue'
import DashboardLayoutPages from '@/layouts/DashboardLayoutPages/index.js'
import { getItem } from '@/models/session';

const allChidrenShifts = [
	{
		path: "calendario/:shiftId?",
		name: "Calendário",
		meta: { icon: "event", permissionType: null },
		component: DashboardLayoutPages.ShiftsCalendar
	},
	{
		path: "relatorio",
		name: "Relatório",
		meta: { icon: "timeline", permissionType: null },
		component: DashboardLayoutPages.ShiftsReport
	},
	{
		path: 'novos-profissionais-saude/:id?',
		name: 'Novos profissionais',
		meta: { icon: 'library_add', permissionType: null },
		component: DashboardLayoutPages.ShiftsNewHealthProfessionals,
	},
	{
		path: 'profissionais-saude/:id?',
		name: 'Profissionais cadastrados',
		meta: { icon: 'local_hospital', permissionType: null },
		component: DashboardLayoutPages.ShiftsHealthProfessionals,
	},
	{
		path: 'cnes/:id?',
		name: 'CNES',
		meta: { icon: 'table_view', permissionType: null },
		component: DashboardLayoutPages.CNESReport,
	},
];

let user = getItem("user");

// Tabs released for client type users
const clientFilterChildrenShifts = [
	'Calendário',
]
const routes = [
	{
		path: '/',
		redirect: '/login',
		component: AuthLayout,
		name: 'Authentication',
		children: [
			{
				path: '/login',
				name: 'Login',
				component: AuthLayoutPages.Login
			},
			{
				path: '/exclusao-de-conta',
				name: 'Exclusão de Conta',
				component: AuthLayoutPages.AccountDeletion
			},
			{
				path: '/politica-de-privacidade',
				name: 'Política de Privacidade',
				component: AuthLayoutPages.PrivacyPolicy
			},
		],
	},
	{
		path: '/',
		component: DashboardLayout,
		children: [
			{
				path: 'escalas',
				name: 'Escalas',
				redirect: '/escalas/calendario',
				meta: { icon: 'calendar_today', dashboardModule: 'SHIFTS', permissionType: null },
				component: DashboardLayoutPages.Primary,
				children: user && user.role == 'CLIENT' ? allChidrenShifts.filter(children => clientFilterChildrenShifts.includes(children.name)) : allChidrenShifts,
			},
			{
				path: 'administrativo',
				name: 'Administrativo',
				redirect: '/administrativo/usuarios',
				meta: { icon: 'bar_chart', dashboardModule: 'ADMIN', permissionType: null },
				component: DashboardLayoutPages.Primary,
				children: [
					{
						path: 'usuarios/:id?',
						name: 'Usuários sistema',
						meta: { icon: 'person', permissionType: null },
						component: DashboardLayoutPages.AdminUsers,
					},
					{
						path: 'administradora/:id?',
						name: 'Administradoras',
						meta: { icon: 'account_balance', permissionType: null },
						component: DashboardLayoutPages.AdminUnitManagers,
					},
					{
						path: 'unidades/:id?',
						name: 'Unidades de saúde',
						meta: { icon: 'store', permissionType: null },
						component: DashboardLayoutPages.AdminUnits,
					},
					{
						path: 'profissionais-internos/:id?',
						name: 'Profissionais internos',
						meta: { icon: 'group', permissionType: null },
						component: DashboardLayoutPages.AdminInhouseProfessionals,
					},
					{
						path: 'servicos/:kind?/:id?',
						name: 'Serviços',
						meta: { icon: 'dns', permissionType: null },
						component: DashboardLayoutPages.AdminServices,
					},
					{
						path: 'tipos-plantao/:id?',
						name: 'Tipos de plantão',
						meta: { icon: 'label', permissionType: null },
						component: DashboardLayoutPages.AdminShiftKinds,
					},
				],
			},
			{
				path: 'financeiro',
				name: 'Financeiro',
				redirect: '/financeiro/contas-pagar',
				meta: { icon: 'work', dashboardModule: 'FINANCE', permissionType: null },
				component: DashboardLayoutPages.Primary,
				children: [
					{
						path: 'contas-pagar/:id?',
						name: 'Contas a pagar',
						meta: { icon: 'money_off', permissionType: null },
						component: DashboardLayoutPages.FinanceAccountsPayable,
					},
					{
						path: 'contas-receber/:id?',
						name: 'Contas a receber',
						meta: { icon: 'attach_money', permissionType: null },
						component: DashboardLayoutPages.FinanceAccountsReceivable,
					},
					{
						path: 'folha-pagamento/:id?',
						name: 'Folha de pagamento',
						meta: { icon: 'import_contacts', permissionType: null },
						component: DashboardLayoutPages.FinancePayroll,
					},
					{
						path: 'pagamentos-vista/:id?',
						name: 'Pagamentos à vista',
						meta: { icon: 'payments', permissionType: null, hasNewActivity: null },
						component: DashboardLayoutPages.FinanceLumpSumPayments,
					},
					{
						path: 'arquivos-bancarios/:id?',
						name: 'Arquivos bancários',
						meta: { icon: 'request_quote', permissionType: null },
						component: DashboardLayoutPages.FinanceBankingFiles,
					},
				],
			},
			{
				path: 'relatorios',
				name: 'Relatórios',
				redirect: '/relatorios/dia-fim-semana',
				meta: { icon: 'timeline', dashboardModule: 'REPORTS', permissionType: null },
				component: DashboardLayoutPages.Primary,
				children: [
					{
						path: 'dia-fim-semana/:id?',
						name: 'Dia x Fim Semana',
						meta: { icon: 'date_range', permissionType: null },
						component: DashboardLayoutPages.ReportWeekdayWeekend,
					},
					{
						path: 'prestacao-contas/:id?',
						name: 'Prestação de contas',
						meta: { icon: 'calendar_view_month', permissionType: null },
						component: DashboardLayoutPages.ValidatedShiftsReport,
					},
					{
						path: 'contabilidade/:id?',
						name: 'Contabilidade',
						meta: { icon: 'assignment', permissionType: null },
						component: DashboardLayoutPages.AccountabilityReport,
					},
					{
						path: 'repasse-analitico/:id?',
						name: 'Repasse analítico',
						meta: { icon: 'table_view', permissionType: null },
						component: DashboardLayoutPages.AnalyticalTransferReport,
					},
					{
						path: 'total-medicos/:id?',
						name: 'Total de médicos',
						meta: { icon: 'ballot', permissionType: null },
						component: DashboardLayoutPages.ShiftsPerSpecialtyReport,
					},
					{
						path: 'pagamentos-vista',
						name: 'Pagamentos à Vista',
						meta: { icon: 'account_balance_wallet', permissionType: null },
						component: DashboardLayoutPages.LumpSumPaymentsReport,
					},
					{
						path: 'total-horas-valor/:id?',
						name: 'Total Horas x Valor',
						meta: { icon: 'timelapse', permissionType: null },
						component: DashboardLayoutPages.TotalHoursValueReport,
					},
				],
			},
			{
				path: 'configuracoes',
				name: 'Configurações',
				meta: { icon: 'settings', dashboardModule: 'SETTINGS', permissionType: null },
				redirect: '/configuracoes/sistema',
				component: DashboardLayoutPages.Primary,
				children: [
					{
						path: 'sistema',
						name: 'Sistema Interno',
						meta: { icon: 'computer', permissionType: null },
						component: DashboardLayoutPages.DashboardSettings,
					},
				],
			},
		]
	},
	{
		path: '*',
		redirect: '/escalas',
		component: DashboardLayout,
		name: 'NoteFound',
	},
];

const router = new VueRouter({
	mode: "history",
	routes,
	linkActiveClass: "nav-item active",
});

export default router;
